var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b1t-okraina-catalog"},[_c('b1t-okraina-catalog-sections',{attrs:{"drop_page_loading":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }